export interface ProfileMetadata {
    name?: string;
    display_name?: string;
    about?: string;
    picture?: string;
    website?: string;
    nip05?: string;
    lud16?: string;
}

interface CachedProfile {
    metadata: ProfileMetadata;
    timestamp: number;
}

class ProfileCache {
    private cache = new Map<string, CachedProfile>();

    set(pubkey: string, metadata: ProfileMetadata) {
        this.cache.set(pubkey, {
            metadata,
            timestamp: Date.now()
        });
    }

    get(pubkey: string): ProfileMetadata | null {
        const cached = this.cache.get(pubkey);
        if (!cached) return null;

        // Cache for 1 hour
        const isExpired = Date.now() - cached.timestamp > 1000 * 60 * 60;
        if (isExpired) {
            this.cache.delete(pubkey);
            return null;
        }

        return cached.metadata;
    }

    clear() {
        this.cache.clear();
    }
}

export const profileCache = new ProfileCache();
